// extracted by mini-css-extract-plugin
export default {"left":"Heading_left__qpsTG","under":"Heading_under__rVHEd"};